export const commonBundle = {
  logout: { ko: "로그아웃", en: "Logout", es: "Cerrar sesión" },
  admin: { ko: "관리자 페이지", en: "Admin Page", es: "Página de administración" },
  myPage: { ko: "마이페이지", en: "My Page", es: "Mi página" },
  dong: { ko: "{dong} 동", en: "Building {dong}", es: "Edificio {dong}" },
  ho: { ko: "{ho}호", en: "Unit {ho}", es: "Unidad {ho}" }
}
